import React from "react";

const Equipment = () => {
  const products = [
    {
      id: 1,
      name: "Fume Hood OS-FH Series",
      image: "/img/2-6-Units-Magnetic-Stirring-Heating-Mantle-Heating-Mantle-4-500x500.jpg",
    },
    {
      id: 2,
      name: "Dry Oven",
      image: "/img/2-6-Units-Magnetic-Stirring-Heating-Mantle-Heating-Mantle-5-500x500.jpg",
    },
    {
      id: 3,
      name: "Electro Thermal Blast Drying Oven",
      image: "/img/2-6-Units-Magnetic-Stirring-Heating-Mantle-Heating-Mantle-6-500x500.jpg",
    },
    {
      id: 4,
      name: "Atomic Absorption Spectrophotometer OS-4-25-110 Series",
      image: "/img/Atomic-Absorption-Spectrophotometer-OS-4-25-110-Series-500x500.jpg",
    },
    {
      id: 5,
      name: "Hot Plate Magnetic Stirrer",
      image: "/img/Ceramic-Magnetic-Stirrer--500x500.jpg",
    },
    {
      id: 6,
      name: "Rotator",
      image: "/img/Rotator-500x500.jpg",
    },
    {
      id: 7,
      name: "Semi-Preparative and High Pressure Semi & Preparative Types HPLC",
      image: "/img/Semi-Preparative-and-High-Pressure-Semi-Preparative-Types-HPLC-500x500.jpg",
    },
    {
      id: 8,
      name: "Micro Plate Mixers",
      image: "/img/Micro-Plate-Mixers-500x500.jpg",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header Section */}
      <header className="bg-white shadow-sm py-10 text-center">
        <h1 className="text-3xl font-bold text-gray-900">Laboratory Equipment</h1>
        <p className="text-gray-500 mt-2">
          Explore our premium range of lab instruments and tools
        </p>
      </header>

      {/* Product Grid */}
      <main className="max-w-7xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition duration-300 overflow-hidden group"
          >
            <div className="relative">
              <img
                src={product.image}
                alt={product.name}
                loading="lazy"
                className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>

            <div className="p-5 text-center">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-blue-600">
                {product.name}
              </h2>
              <p className="text-gray-600 text-sm">
                {product.name} is an essential tool for modern laboratories, designed for accuracy and reliability.
              </p>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
};

export default Equipment;
